import React from "react";
import _ from "underscore";
import SizeDropdown from "../common/SizeDropdown";
import { AVAILABILITIES, ORDER_TYPE } from "helpers/swaps-helper";
import { numberOfReplacements } from "helpers/exchange-helper";

class SwapsFormFields extends React.Component {
  UNSAFE_componentWillMount() {
    const { product } = this.props;

    if (product.skus.length === 1) {
      const currentSku = _.first(product.skus);
      this.setState({
        currentSku,
      });
    }
  }

  handleSizeChange(e) {
    const { product } = this.props;
    const currentSku = _.find(product.skus, x => x.id === e);
    this.setState({
      currentSku,
    });
  }

  handleSelectReplacement() {
    const { selectReplacement } = this.props;
    selectReplacement(this.state.currentSku);
  }

  renderSizeDropdown() {
    const {
      product,
      userProblems: { problemGroup },
    } = this.props;
    const { orderType } = problemGroup;
    const { currentSku } = this.state || {};
    const { id } = currentSku || {};
    //if product is accessory doesn't need dropdown
    if (product.skus.length === 1) return null;

    const availabilityKey = orderType === ORDER_TYPE.UNLIMITED ? AVAILABILITIES.unlimited : AVAILABILITIES.classic;

    return (
      <SizeDropdown
        selectorName="currentSku"
        skus={product.skus}
        primaryValue={id}
        availabilityKey={availabilityKey}
        onChange={this.handleSizeChange.bind(this)}
      />
    );
  }

  renderButton() {
    const { currentSku } = this.state || {};
    const {
      userProblems: {
        replacements,
        problemGroup: { newGroup, problemBookings, bonusSwap },
      },
    } = this.props;
    const numBonusReplacements = bonusSwap ? 1 : 0;
    const numAvailableReplacements = newGroup
      ? numberOfReplacements(problemBookings.length)
      : problemBookings.length + numBonusReplacements;

    if (numAvailableReplacements === replacements.length) {
      return (
        <div className="swaps-form-fields__explanation">
          Please remove 1 item from your bag in order to select this style.
        </div>
      );
    }

    return (
      <button
        disabled={!currentSku}
        className="btn swaps-form-fields__cta"
        onClick={this.handleSelectReplacement.bind(this)}>
        Add to Bag
      </button>
    );
  }

  render() {
    return (
      <div className="swaps-form-fields">
        {this.renderSizeDropdown()}
        {this.renderButton()}
      </div>
    );
  }
}

export default SwapsFormFields;
